import { makeStyles, theme, IconButton } from '@archer-technologies/ui-components';
import { createElement } from 'react';
var useStyles = makeStyles(function () {
  return {
    gridExpandButtonIcon: {
      color: theme.palette.grey[900]
    },
    hiddenButton: {
      visibility: 'hidden'
    }
  };
});

var treeExpandIcon = function treeExpandIcon(gridTranslations) {
  return function (_ref) {
    var expanded = _ref.expanded,
        onToggle = _ref.onToggle,
        visible = _ref.visible;

    var _useStyles = useStyles(),
        gridExpandButtonIcon = _useStyles.gridExpandButtonIcon,
        hiddenButton = _useStyles.hiddenButton;

    var groupIconExpandLabel = gridTranslations.groupIconExpandLabel,
        groupIconCollapseLabel = gridTranslations.groupIconCollapseLabel;
    return /*#__PURE__*/createElement(IconButton, {
      icon: expanded ? 'ArrowDropDown' : 'ArrowRight',
      label: expanded ? groupIconCollapseLabel : groupIconExpandLabel,
      onClick: onToggle,
      className: visible ? "".concat(gridExpandButtonIcon) : "".concat(gridExpandButtonIcon, " ").concat(hiddenButton),
      tabIndex: visible ? 0 : -1
    });
  };
};

export { treeExpandIcon };